import { createContext, useContext } from 'react'

import type { IInvestorAnalysisDefinitionSchemaV1 } from '~/@api/generated-api-types-user/Api'

// Texty otázok, možnosti a body verzie 1 drží API (jediný zdroj). `QuestionsProviderV1`
// ich načíta raz pri otvorení dotazníka a kroky ich čítajú cez `useQuestionsV1`.

export const QuestionsContextV1 =
  createContext<IInvestorAnalysisDefinitionSchemaV1 | null>(null)

export function useQuestionsV1() {
  const questions = useContext(QuestionsContextV1)
  if (!questions) {
    throw new Error('QuestionsProviderV1 is not initialized')
  }
  return questions
}
